import { useLocation } from 'react-router-dom'

export function getStoreNavActive(pathname: string, search = '') {
  const params = new URLSearchParams(search)
  const sort = params.get('sort')
  const isProductDetail = /^\/shop\/[^/]+$/.test(pathname)

  return {
    isHome: pathname === '/',
    isShop:
      (pathname === '/shop' && sort !== 'new') || isProductDetail,
    isNewArrivals: pathname === '/shop' && sort === 'new',
    isContact: pathname === '/contact',
    isSearch: pathname === '/search',
    isOrders: pathname === '/orders' || pathname.startsWith('/orders/'),
    isWishlist: pathname === '/wishlist',
    isCart: pathname === '/cart',
  }
}

export function useStoreNavActive() {
  const { pathname, search } = useLocation()
  return getStoreNavActive(pathname, search)
}
